import React from "react";
import { ContentTypeRender } from "nystem-components";

const MediaCheckOrientationStatus = ({ model, value }) => {
  const { item, ifPdf } = model;
  value = value || [];
  if (ifPdf) {
    if (!value.find((item) => item.ext === "pdf")) return null;
  } else if (!value.find((item) => !item.orientation)) return null;

  return <ContentTypeRender items={item} />;
};
export default MediaCheckOrientationStatus;
